import { useEffect, useState } from "react";
import reportApi from "../../../../../api/reportApi";

/**
 * Fetch the tags report (akabiz tags + Zalo tags) for the current filters.
 * Mirrors the pattern used by usePipelineReport — cancelled flag guards
 * against rapid filter changes.
 */
export function useTagsReport({ shopId, accountId, from, to }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!shopId || !accountId || !from || !to) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    reportApi
      .getTags({ shopId, accountId, from, to })
      .then((res) => {
        if (cancelled) return;
        if (res.status === 1) setData(res.data);
        else setError(res.message || "Không tải được dữ liệu");
      })
      .catch((err) => !cancelled && setError(err.message))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [shopId, accountId, from, to]);

  return { data, loading, error };
}
